import { AccountData } from '../../api';
import { customerFacingPriceFormatter } from '../../orderPage/utils';

export const amountRangeLabel = (account: AccountData, translate: (key: string, options?: object) => string) => {
  const settings = account.monetary_voucher_settings;
  const presetAmounts = settings?.preset_amounts ?? [];
  const lowestAmount = Math.min(
    ...presetAmounts,
    settings?.allow_custom_amount ? settings.min_amount ?? Infinity : Infinity,
  );
  const highestAmount = Math.max(...presetAmounts, settings?.allow_custom_amount ? settings.max_amount ?? 0 : 0);
  if (!Number.isFinite(lowestAmount) || highestAmount <= 0) {
    return '';
  }
  return translate('storefront.giftCardAmountRange', {
    min: customerFacingPriceFormatter(lowestAmount, account),
    max: customerFacingPriceFormatter(highestAmount, account),
  });
};
